import { Dialog, Drawer } from "@mui/material";
import Bell02 from "@untitled-ui/icons-react/build/esm/Bell02";
import ChevronDown from "@untitled-ui/icons-react/build/esm/ChevronDown";
import ChevronLeft from "@untitled-ui/icons-react/build/esm/ChevronLeft";
import ChevronRight from "@untitled-ui/icons-react/build/esm/ChevronRight";
import Expand06 from "@untitled-ui/icons-react/build/esm/Expand06";
import Power01 from "@untitled-ui/icons-react/build/esm/Power01";
import Search from "@untitled-ui/icons-react/build/esm/SearchSm";
import UserCircle from "@untitled-ui/icons-react/build/esm/UserCircle";
import moment from "moment/moment";
import { useCallback, useContext, useEffect, useRef, useState } from "react";
import { flushSync } from "react-dom";
import { useSelector } from "react-redux";
import { Link, useLocation, useNavigate, useNavigationType } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import styled from "styled-components";
import { premiumButtonLabelAlignment } from "../premium/PremiumHeaderButton";
import { v4 as uuidv4 } from "uuid";
import AppContext from "../../../AppContext";
import LayoutContext from "../../../LayoutContext";
import * as Library from "../../../utils/Library";
import { verifyUserIsOnboarding } from "../../../utils/onboardingHelper";
import DialogBoxComponent from "../dialogs/DialogBoxComponent";
import FullScreenOverlay from "../overlay/FullScreenOverlay";
import NotificationPanel from "./NotificationPanel";
import NotificationsDropdown from "./NotificationsDropdown";
import UserProfileDropdown from "./UserProfileDropdown";

// #region SCOPED CSS
const StyledPage = styled.div`
    position: relative;
    min-width: 0;

    @media only screen and (max-width: 1200px) {
        .main-header .center-btns { display: none; flex: 0; }
        .main-header .left-btns { flex-basis: initial !important; min-width: 120px; }
    }
    @media only screen and (max-width: 1756px) {
        &.isSidePanelOpen .main-header .left-btns { display: none; }
        &.isSidePanelOpen .main-header .center-btns { display: none; margin-left: 18px; }
    }

    .left-btns, .center-btns, .right-btns {
        display: flex;
        flex-grow: 1;
        flex-basis: 100%;
        min-width: 0;
    }
    .main-header.navbar.navbar-expand {
        align-items: center;
        background: #0e0f10;
        border: 0;
        border-bottom: 1px solid rgba(255, 255, 255, 0.1);
        border-radius: 0;
        box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.035), 0 3px 12px rgba(0, 0, 0, 0.16);
        display: flex;
        flex-flow: row nowrap;
        justify-content: center;
        margin: 0;
        z-index: 2;
        overflow: hidden;
        height: var(--bostager-main-header-height);
        box-sizing: border-box;
    }
    .right-btns { min-width: 320px; }
    .left-btns {
        min-width: 120px;
        padding-left: 24px;
        align-items: center;
        height: 70px;
        justify-content: flex-start;
    }
    .left-btns ul { margin: 0; padding: 0; white-space: nowrap; }
    .left-btns ul li { display: inline-block; list-style-type: none; }
    .left-btns ul li a {
        align-items: center;
        background: linear-gradient(180deg, #252729, #1a1c1e);
        border: 1px solid rgba(255, 255, 255, 0.1);
        border-radius: 6px;
        box-sizing: border-box;
        color: var(--text-icons-gray-100);
        display: flex;
        font-size: 15px;
        height: 37px;
        justify-content: center;
        line-height: 37px;
        padding: 0;
        text-align: center;
        text-decoration: none;
        width: 40px;
    }
    .left-btns ul li a.disabled { opacity: 0.5; cursor: not-allowed; }
    .main-header .center-btns {
        min-width: max-content;
        align-items: center;
        height: 70px;
        justify-content: center;
    }
    .main-header .center-btns .btn.btn-success {
        ${premiumButtonLabelAlignment}
        font-size: 12px;
        height: 35px;
        min-width: 120px;
        width: 120px;
        padding: 0;
    }
    .main-header .btn.btn-success {
        align-items: center;
        background: linear-gradient(180deg, #252729, #1a1c1e);
        border: 1px solid rgba(255, 255, 255, 0.1);
        border-radius: 6px;
        box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.035);
        color: var(--text-icons-gray-100);
        display: flex;
        font-family: "Roboto", sans-serif;
        font-size: 11px;
        font-weight: 500;
        letter-spacing: 0.35px;
        justify-content: center;
        margin: 0 5px;
        text-transform: uppercase;
    }
    .main-header a {
        transition: background-color 140ms ease, border-color 140ms ease, box-shadow 140ms ease;
    }
    .main-header .btn.btn-success:not(.button-not-active):hover,
    .left-btns ul li a:not(.disabled):hover,
    .main-header .notification-bell > a:hover,
    .main-header .user-profile-dropdwon:hover,
    .main-header .user-profile-dropdwon[aria-expanded="true"] {
        background: linear-gradient(180deg, #302c25, #211f1b);
        border-color: rgba(239, 191, 115, 0.55);
    }
    .main-header a:focus-visible {
        /* App.css suppresses link outlines globally; restore header keyboard focus. */
        outline: 2px solid #efbf73 !important;
        outline-offset: -3px !important;
    }
    .main-header .btn.btn-success.button-not-active {
        background: #1a1c1e;
        border-color: rgba(255, 255, 255, 0.07);
        color: var(--text-icons-gray-300);
        box-shadow: none;
        cursor: not-allowed;
    }
    .main-header .navbar-nav {
        align-items: center;
        float: right;
        height: 70px;
        justify-content: flex-end;
        list-style: none;
        padding-right: 24px;
        padding-left: 0;
    }
    .right-btns .nav-item { margin: 0 0 0 8px; flex-shrink: 0; }
    .right-btns .icon { width: 40px; height: 37px; }
    .main-header .nav-item.dropdown a { text-decoration: none; }
    .nav-item .nav-link { color: var(--text-icons-gray-100); display: block; font-size: 16px; }
    .nav-item.notification-bell > a {
        display: flex;
        align-items: center;
        justify-content: center;
        background: linear-gradient(180deg, #252729, #1a1c1e);
        border: 1px solid rgba(255, 255, 255, 0.1);
        border-radius: 6px;
    }
    .notification-bell-container { position: relative; display: flex; justify-content: center; align-items: center; }
    .notification-badge {
        height: 19px;
        min-width: 19px;
        background-color: red;
        border: 2px solid #141617;
        border-radius: 10px;
        position: absolute;
        top: -12px;
        right: -9px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 12px;
        font-weight: 500;
        color: #fff;
        line-height: 100%;
        padding: 0 5px;
        text-align: center;
    }
    .nav-item.dropdown.profile-container a {
        display: flex;
        align-items: center;
        text-decoration: none;
        min-width: 0;
        padding: 5px 8px;
        border: 1px solid transparent;
        border-radius: 6px;
    }
    .profile-container { margin: 0 8px !important; min-width: 0; flex-shrink: 1 !important; }
    .profile-text { display: grid; margin-right: 10px; height: 33px; min-width: 0; max-width: 160px; }
    .profile-text.is-hidden { display: none; }
    .profile-text > span {
        color: var(--text-icons-gray-100);
        display: block;
        font-family: "Roboto", sans-serif;
        line-height: 18px;
        text-align: right;
        text-transform: capitalize;
        text-overflow: ellipsis;
        width: 100%;
        white-space: nowrap;
        overflow: hidden;
    }
    .profile-text .username { font-size: 14px; font-weight: 500; line-height: 18px; height: 20px; }
    .profile-text .user-designation { font-size: 11px; font-weight: 400; color: #aaa9a5; }
    .profile-picture-container {
        display: flex;
        flex-shrink: 0;
        border-radius: 50%;
        box-shadow: 0 0 0 1px rgba(239, 191, 115, 0.3);
        background: #0e0f10;
    }
    .profile-picture-container > svg > path { stroke-width: 0.5; }
    .profile-picture { border-radius: 50%; height: 35px; width: 35px; object-fit: cover; }
    .profile-container .dropdown-icon { margin-left: 10px; width: 16px; height: 16px; flex-shrink: 0; }
    .nav-link.btn.btn-success { font-size: 16px; height: 37px; margin: 0; padding: 6px 12px; width: 40px; }
    .right-btns .nav-item.logout-btn { margin-right: 0; }
    .nav-item.logout-btn .nav-link { color: var(--text-icons-green-500); margin-right: 0; }

    .notifications-dropdown {
        opacity: 0;
        visibility: hidden;
        transition: opacity 140ms ease, visibility 140ms ease;
        position: absolute;
        top: 58px;
        right: 25px;
        z-index: 9999999;
    }
    .notifications-dropdown.show, .user-profile-dropdown.show { opacity: 1; visibility: visible; }
    .user-profile-dropdown {
        opacity: 0;
        visibility: hidden;
        transition: opacity 140ms ease, visibility 140ms ease;
        position: absolute;
        top: 70px;
        right: min(224px, max(16px, calc(100% - 292px)));
        z-index: 9999999;
        width: 276px;
        max-width: calc(100% - 32px);
        max-height: calc(100dvh - 126px);
        overflow-y: auto;
        box-sizing: border-box;
        border: 1px solid rgba(255, 255, 255, 0.1);
        border-radius: 8px;
        padding: 10px;
        box-shadow: 0 16px 36px rgba(0, 0, 0, 0.35), inset 0 1px 0 rgba(255, 255, 255, 0.035);
        background: linear-gradient(145deg, #202224, #141617 55%, #0e0f10);
    }
    @media (prefers-reduced-motion: reduce) {
        .main-header a, .notifications-dropdown, .user-profile-dropdown { transition: none; }
    }
`;
// #endregion

const SessionExpiryDialog = styled(Dialog)`
    && { z-index: 2147483000; }
    .MuiBackdrop-root { background: rgba(16, 20, 27, 0.8); }
    .MuiDialog-paper {
        margin: 16px;
        width: calc(100% - 32px);
        max-width: 400px;
        border: 1px solid rgba(255, 255, 255, 0.35);
        border-radius: 20px;
        background: rgba(20, 22, 23, 0.94);
        color: #f5f5f5;
        box-shadow: 0 16px 48px rgba(0, 0, 0, 0.3);
        backdrop-filter: blur(8px);
        @supports (backdrop-filter: blur(8px)) { background: rgba(20, 22, 23, 0.78); }
    }
    .session-expiry-card { padding: 32px 24px; text-align: center; font-family: Roboto, sans-serif; }
    h2 { margin: 0 0 20px; color: #efbf73; font-size: 17px; font-weight: 500; }
    p { margin: 0; color: #d1d1d1; font-size: 14px; line-height: 1.6; }
    .session-expiry-countdown { margin: 20px 0 24px; color: #efbf73; font-size: 40px; font-variant-numeric: tabular-nums; }
    button {
        width: 100%; min-height: 44px; padding: 10px 16px;
        border: 1px solid #efbf73; border-radius: 8px; background: #080909;
        color: #efbf73; font-size: 13px; font-weight: 500; cursor: pointer;
    }
    button:hover { background: rgba(239, 191, 115, 0.12); }
    button:focus-visible { outline: 2px solid #efbf73; outline-offset: 4px; }
`;

// #region CONSTANTS
const PROFILE_TEXT_MIN_RIGHT_BUTTONS_WIDTH = 400;
// #endregion

/** Header component for the main application.
 * @component
 * @param {Object} props - The props object.
 * @param {string} props.className - The CSS class name for the component.
 * @returns {JSX.Element} The JSX element representing the header.
 */
function Header(props) {
    // #region VARS
    const rightButtonsRef = useRef(null);
    const navigate = useNavigate();
    const navigations = useSelector(state => state.navigationAccesses);

    const [showNotificationDropdown, setShowNotificationDropdown] = useState(false);
    const [showNotificationPanel, setShowNotificationPanel] = useState(false);
    const [isLoadingNotifications, setIsLoadingNotifications] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [notificationItems, setNotificationItems] = useState([]);
    const { showLogoutPopup, setShowLogoutPopup } = useContext(LayoutContext);
    const { hasUnsavedChanges, setHasUnsavedChanges, setShowUnsavedChangesPopup, setPageRefreshFromNotification, aiChatSidePanelOpen } = useContext(AppContext);
    const [groupedUnreadNotifications, setGroupedUnreadNotifications] = useState({});
    const [readNotifications, setReadNotifications] = useState([]);
    /* const hasSubscriptionPlan = ![null, undefined, "", "undefined", "null"].includes(
        localStorage?.getItem("subscriptionPlanID")
    );*/
    const userIsOnboarding = verifyUserIsOnboarding(navigations?.navigationAccesses) !== "/dashboard";

    const [unreadCounts, setUnreadCounts] = useState(0);
    const [newUnreadCounts, setNewUnreadCounts] = useState(0);
    const [hasNextPage, setHasNextPage] = useState(false);
    const [readNotificationCount, setReadNotificationCount] = useState(0);
    const [loadMoreLoading, setLoadMoreLoading] = useState(false);
    const hasOrganizationName = ![null, undefined, "", "undefined", "null"].includes(
        localStorage?.getItem("currentOrganizationName")
    );
    const [showUserProfileDropdown, setShowUserProfileDropdown] = useState(false);
    const [isProfileTextVisible, setIsProfileTextVisible] = useState(true);
    // #endregion

    // #region EFFECTS
    useEffect(() => {
        const rightButtonsElement = rightButtonsRef.current;
        if (!rightButtonsElement) return undefined;

        const updateProfileTextVisibility = () => {
            const shouldShowProfileText =
                rightButtonsElement.getBoundingClientRect().width >= PROFILE_TEXT_MIN_RIGHT_BUTTONS_WIDTH;

            setIsProfileTextVisible(currentValue =>
                currentValue === shouldShowProfileText ? currentValue : shouldShowProfileText
            );
        };

        updateProfileTextVisibility();

        const resizeObserver = new ResizeObserver(updateProfileTextVisibility);
        resizeObserver.observe(rightButtonsElement);

        return () => resizeObserver.disconnect();
    }, []); //Objective: this will toogle profile name visibility when profile text width is less than PROFILE_TEXT_MIN_RIGHT_BUTTONS_WIDTH

    useEffect(() => {
        const handleClickOutside = event => {
            if (showNotificationDropdown && event.target.closest(".notification-bell")) {
            } else if (showNotificationDropdown && !event.target.closest(".notifications-dropdown")) {
                setShowNotificationDropdown(false);
                // if (hasNewNotifications()) {
                //     setAllSentNotificationsAsSeen();
                // }
            }
        };

        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [showNotificationDropdown]);

    useEffect(() => {
        const handleClickOutsideProfile = event => {
            if (showUserProfileDropdown && event.target.closest(".user-profile-dropdwon")) {
            } else if (showUserProfileDropdown && !event.target.closest(".user-profile-dropdown")) {
                setShowUserProfileDropdown(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutsideProfile);
        return () => {
            document.removeEventListener("mousedown", handleClickOutsideProfile);
        };
    }, [showUserProfileDropdown]);

    useEffect(() => {
        const isDev = process.env.REACT_APP_SHOW_DEV_TOOLS === "true";
        const intervalTime = isDev ? 20 * 1000 : 10 * 1000;

        const interval = setInterval(() => {
            getNewNotifications();
            //getHeaderNotifications(["New"], "", undefined);
        }, intervalTime);

        getHeaderNotifications();

        return () => {
            clearInterval(interval);
        };
    }, []);

    useEffect(() => {
        if (newUnreadCounts) {
            setUnreadCounts(parseInt(unreadCounts) + parseInt(newUnreadCounts));
            setNewUnreadCounts(0);
        }
    }, [newUnreadCounts]);
    // #endregion

    // #region METHODS
    const getNotificationTitleAndDescription = notificationInfo => {
        let title = "Unknown Notification";
        let description = "You have received an unknown notification.";

        if (notificationInfo?.type === "InviteRetailerFromRetailBrand") {
            if (notificationInfo?.subType === "Update") {
                if (notificationInfo?.subStatus === "Accepted") {
                    title = "Request accepted!";
                    description = `The request sent by ${notificationInfo?.inviteInfo?.contactFirstName} from ${notificationInfo?.labelBrandInfo?.name} to ${notificationInfo?.retailBrandInfo?.name} was accepted.`;
                } else {
                    title = "Your request has been updated";
                    description = `Your request to ${notificationInfo?.labelBrandInfo?.name} from your brand ${
                        notificationInfo?.retailBrandInfo?.name
                    } has updated to: ${
                        notificationInfo?.subStatus ?? notificationInfo?.inviteInfo?.status?.status ?? "Unknown Status"
                    }`;
                }
            }
        } else if (notificationInfo?.type === "InviteRetailerFromLabelBrand") {
            if (notificationInfo?.subType === "New") {
                title = "You received a new invite.";
                description = `${notificationInfo?.retailBrandInfo?.name} received a new invite from ${notificationInfo?.labelBrandInfo?.name}`;
            } else if (notificationInfo?.subType === "Update") {
                if (notificationInfo?.subStatus === "Voided") {
                    title = "Invite update!";
                    description = `The invite from ${notificationInfo?.labelBrandInfo?.name} to ${notificationInfo?.retailBrandInfo?.name} was revoked.`;
                }
            }
        } else if (notificationInfo?.type === "FFC") {
            /* if (notificationInfo?.subType === "New") {
                title = "Activated fullfillment center";
                description = `${notificationInfo?.labelBrandInfo?.name} activated a fulfillment center with your store ${notificationInfo?.storeInfo?.name}`;
            } */

            if (notificationInfo?.subType === "Update") {
                const statusChangeBy = notificationInfo?.fulfillmentCenterInfo?.currentStatus?.statusChangeBy;
                const statusChangeReason = notificationInfo?.fulfillmentCenterInfo?.currentStatus?.statusChangeReason;
                const subStatus = notificationInfo?.subStatus;

                if (subStatus === "Active") {
                    title = "Fulfilment center reactivated!";
                    description = `${notificationInfo?.storeInfo?.name} is now reconnected to ${notificationInfo?.labelBrandInfo?.name}.`;
                    //description example: Follestad Oslo is now reconnected to Gant.
                } else if (subStatus === "Suspended") {
                    if (statusChangeBy === "LabelBrand") {
                        title = "A store was disconnected!";
                        description = statusChangeReason
                            ? `${notificationInfo?.labelBrandInfo?.name} disconnected ${notificationInfo?.storeInfo?.name} from ${notificationInfo?.retailBrandInfo?.name} due to: ${statusChangeReason}.`
                            : `${notificationInfo?.labelBrandInfo?.name} disconnected ${notificationInfo?.storeInfo?.name} from ${notificationInfo?.retailBrandInfo?.name}.`;
                        //description example: Follestad disconnected Follestad Oslo from Gant due to: "Store is too far away"
                    }
                }
            } else if (notificationInfo?.subType === "Remind") {
                title = "Reminder to activate connection!";
                description = `${notificationInfo?.sentByBOstagesAccountInfo?.firstName} sent a reminder to connect ${notificationInfo?.storeInfo?.name} to ${notificationInfo?.labelBrandInfo?.name}.`;
            }
        } else if (notificationInfo?.type === "ProductsUpdated") {
            title = "Products updated";
            const labelBrandName = notificationInfo?.labelBrandInfo?.name || "A connected label brand";
            const counts = notificationInfo?.customData;
            const changes = [
                { count: counts?.totalProductsCreated, label: "product", action: "created" },
                { count: counts?.totalProductsUpdated, label: "product", action: "updated" },
                { count: counts?.totalGTINsCreated, label: "variant", action: "created" },
                { count: counts?.totalGTINsUpdated, label: "variant", action: "updated" }
            ];
            if (changes.every(({ count }) => Number.isFinite(count) && count >= 0)) {
                const summary = changes
                    .map(({ count, label, action }) => `${count} ${label}${count === 1 ? "" : "s"} ${action}`)
                    .join(", ");
                description = `${labelBrandName}: ${summary}.`;
            } else description = `${labelBrandName} has new or updated products available.`;
        } else if (notificationInfo?.type === "BrandConnection") {
            if (notificationInfo?.subType === "Update") {
                if (notificationInfo?.subStatus === "Disconnected") {
                    title = "Disconnected!";
                    description = notificationInfo?.connectedBrandInfo?.currentStatus?.disconnectReason
                        ? `${notificationInfo?.labelBrandInfo?.name} disconnected from ${notificationInfo?.retailBrandInfo?.name} due to: ${notificationInfo?.connectedBrandInfo?.currentStatus?.disconnectReason}`
                        : `${notificationInfo?.labelBrandInfo?.name} disconnected from ${notificationInfo?.retailBrandInfo?.name}.`;
                }
                if (notificationInfo?.subStatus === "Connected") {
                    title = `You’ve been reconnected with ${notificationInfo?.labelBrandInfo?.name}`;
                    description = `${notificationInfo?.labelBrandInfo?.name} reconnected to ${notificationInfo?.retailBrandInfo?.name}`;
                }
            }
        }

        return { title, description };
    };

    const getNotificationRedirect = notificationInfo => {
        let destinationPageURL = "#";

        if (notificationInfo?.destinationPage === "BOstageR products page") destinationPageURL = "/products";

        if (notificationInfo?.destinationPage === "BOstageR label brands invites page") {
            if (notificationInfo?.subType === "New") {
                destinationPageURL = "/labelbrands/invitations";
            } else {
                destinationPageURL = "/labelbrands/requests";
            }
        }
        if (notificationInfo?.destinationPage === "BOstageB retailers requests page") {
            if (notificationInfo?.subType === "New") {
                destinationPageURL = "/labelbrands/requests";
            } else {
                destinationPageURL = "/labelbrands/invitations";
            }
        }
        if (notificationInfo?.destinationPage === "BOstageR label brands connections page") {
            if (notificationInfo?.subType === "New") {
                destinationPageURL = "#";
            } else {
                destinationPageURL = "/labelbrands/connections";
            }
        }

        return destinationPageURL;
    };

    const handleOnNewNotificationPageRefresh = notificationInfo => {
        if (notificationInfo?.destinationPage === "BOstageR label brands invites page") {
            //if (notificationInfo?.subType !== "New")
            if (pathname === "/labelbrands/requests") setPageRefreshFromNotification(true);
        }
    };

    const getNewNotifications = () => {
        const BOstagesAccountID = localStorage?.getItem("token");
        if (!BOstagesAccountID) return;

        Library.makeCommonPostRequest("Global", "getNotificationsData", { status: ["New"] }, false).then(res => {
            const { status, message } = res?.data;
            if (status !== 200) return;

            const { notifications, totalDocs } = message;
            const result = notifications ?? [];
            setNewUnreadCounts(totalDocs);

            const notificationsResult = result?.map(notificationInfo => {
                const { title, description } = getNotificationTitleAndDescription(notificationInfo);
                handleOnNewNotificationPageRefresh(notificationInfo);

                return {
                    id: notificationInfo?._id,
                    title: title,
                    description: description
                };
            });

            const getNewNotificationsIds = notificationsResult.map(item => item.id);
            for (let i = 0; i < notificationsResult.length; i++) {
                const item = notificationsResult[i];
                Library.showToastMessage({
                    type: "success",
                    title: item?.title,
                    description: item?.description
                });
            }

            if (getNewNotificationsIds.length > 0) setAllSentNotificationsAsSeen(getNewNotificationsIds);
        });
    };

    const getHeaderNotifications = (
        status = ["New", "Sent"],
        notificationType = "",
        limit = 5,
        page = 1,
        searchText
    ) => {
        const BOstagesAccountID = localStorage?.getItem("token");
        if (!BOstagesAccountID) return;

        if ((notificationType === "Unread" || notificationType === "Read") && page === 1) setIsLoading(true);

        Library.makeCommonPostRequest(
            "Global",
            "getNotificationsData",
            {
                status: status,
                page: page,
                limit: limit,
                searchText
            },
            false,
            setIsLoadingNotifications
        ).then(res => {
            const { status, message } = res?.data;
            if (status !== 200) return;

            const { notifications, hasNextPage, totalDocs } = message;
            setHasNextPage(hasNextPage);
            setIsLoading(false);
            setLoadMoreLoading(false);
            const result = notifications ?? [];

            const notificationsResult = result
                ?.map(notificationInfo => {
                    const { title, description } = getNotificationTitleAndDescription(notificationInfo);
                    const destinationPageURL = getNotificationRedirect(notificationInfo);

                    const createdAt = moment(notificationInfo?.createdAt);
                    const now = moment();
                    const isToday = createdAt.isSame(now, "day");

                    const getCustomTimeFormat = () => {
                        const seconds = now.diff(createdAt, "seconds");
                        const minutes = now.diff(createdAt, "minutes");
                        const hours = now.diff(createdAt, "hours");

                        //const formatValue = value => (value < 10 ? `${value}` : value);
                        const formatValue = value => value;
                        if (seconds < 60) return `${formatValue(seconds)}s`;
                        if (minutes < 60) return `${formatValue(minutes)}m`;
                        return `${formatValue(hours)}h`;
                    };

                    return {
                        id: notificationInfo?._id,
                        title: title,
                        createdAt: isToday
                            ? getCustomTimeFormat() // e.g., "5m", "1hr", "23hrs"
                            : createdAt.isSame(moment().subtract(1, "day"), "day")
                              ? "Yesterday"
                              : createdAt.format("DD/MM/YYYY"), // e.g., "12-03-23"
                        label: isToday ? "Today" : "Before",
                        status: notificationInfo?.status ?? "unknown",
                        type: notificationInfo?.type ?? "unknown",
                        description: description,
                        data: notificationInfo,
                        destinationPageURL: destinationPageURL
                    };
                })
                .sort((a, b) => moment(b?.createdAt).diff(moment(a?.createdAt))); // Sort by createdAt descending

            const grouped = notificationsResult?.reduce((acc, notification) => {
                const { label } = notification;
                if (!acc[label]) {
                    acc[label] = [];
                }
                acc[label].push(notification);
                return acc;
            }, {});

            if (notificationType === "") {
                setUnreadCounts(totalDocs);
                setNotificationItems(notificationsResult);
            }

            if (notificationType === "Unread") {
                setUnreadCounts(totalDocs);
                setReadNotificationCount(totalDocs);
                if (page === 1) {
                    setGroupedUnreadNotifications(grouped);
                } else {
                    setGroupedUnreadNotifications(prev => {
                        const updated = { ...prev };
                        Object.keys(grouped).forEach(label => {
                            updated[label] = [...(updated[label] || []), ...grouped[label]];
                        });
                        return updated;
                    });
                }
            }

            if (notificationType === "Read") {
                if (page === 1) {
                    setReadNotifications(Object.values(grouped).flat());
                } else {
                    setReadNotifications(prev => [...prev, ...Object.values(grouped).flat()]);
                }
            }
        });
    };

    const handleDeleteNotification = notificationID => {
        Library.makeCommonPostRequest(
            "Global",
            "deleteNotifications",
            {
                notificationIDs: [notificationID]
            },
            false,
            null
        ).then(res => {
            getHeaderNotifications();
        });
    };

    const handleReadNotification = notificationID => {
        Library.makeCommonPostRequest(
            "Global",
            "updateNotificationsStatus",
            {
                notificationIDs: [notificationID],
                status: "Seen"
            },
            false,
            null
        ).then(res => {
            getHeaderNotifications();
        });
    };

    const getUnreadNotifications = (page = 1, limit = 20, searchText) => {
        if (page === 1) {
            setGroupedUnreadNotifications({});
        }

        getHeaderNotifications(["New", "Sent"], "Unread", limit, page, searchText);
        setLoadMoreLoading(true);
    };

    const getReadNotifications = (page = 1, limit = 20, searchText) => {
        if (page === 1) {
            setReadNotifications([]);
        }

        getHeaderNotifications(["New", "Sent", "Seen"], "Read", limit, page, searchText);
        setLoadMoreLoading(true);
    };

    const setAllSentNotificationsAsSeen = (ids = []) => {
        const notificationIDs = ids.length
            ? ids
            : notificationItems.filter(item => item.status === "New").map(item => item.id);
        Library.makeCommonPostRequest(
            "Global",
            "updateNotificationsStatus",
            {
                notificationIDs,
                status: "Sent"
            },
            false,
            setIsLoadingNotifications
        ).then(res => {
            //const { status } = res?.data;
            // if (status === 200) {
            //     getUnreadNotifications(1, 5);
            // }
        });
    };

    const handleDestinationPage = destinationPageURL => {
        if (!destinationPageURL) return; // Prevent navigation if URL is null or undefined
        if (window.location.pathname === destinationPageURL) {
            setPageRefreshFromNotification(true);
        } else {
            navigate(destinationPageURL);
        }

        setShowNotificationDropdown(false);
        setShowNotificationPanel(true);
        if (!showNotificationPanel) {
            getUnreadNotifications();
        }
    };

    const toogleFullscreen = e => {
        e.preventDefault();
        if (document.fullscreenElement) {
            document.exitFullscreen();
        } else {
            document.documentElement.requestFullscreen();
        }
    };

    const handleLogoutBtnClick = () => {
        setShowLogoutPopup(true);
    };

    //TODO: CHECK HOW TO CLEAR REDUX VARIABLE
    const clearCacheData = useCallback(() => {
        caches.keys().then(names => {
            names.forEach(name => {
                caches.delete(name);
            });
        });
    }, []);
    // #endregion

    // #region HANDLE BACK AND FORWARD BUTTONS
    const [historyStack, setHistoryStack] = useState([]);
    const { pathname } = useLocation();
    const type = useNavigationType();
    //console.log(historyStack);

    useEffect(() => {
        if (type === "POP") {
            setHistoryStack(prev => prev.slice(0, prev.length - 1));
        } else if (type === "PUSH") {
            setHistoryStack(prev => [...prev, pathname]);
        } else {
            setHistoryStack(prev => [...prev.slice(0, prev.length - 1), pathname]);
        }
    }, [pathname, type]);

    // VERIFIES IF THE PREVIOUS PATH IS WHITIN APP AND IS NOT "/": THAT IS THE ROUTE PATH FOR THE LOGIN PAGE
    const canGoBack =
        window.history.state?.idx !== 0 &&
        (historyStack.length === 1 || (historyStack.length > 1 && historyStack[historyStack.length - 2] !== "/"));
    const canGoForward = window.history.state?.idx < window.history.length - 2;

    function goBack() {
        if (canGoBack) window.history.back();
    }

    function goForward() {
        if (canGoForward) window.history.forward();
    }
    // #endregion

    // #region HANDLE LOGOUT TIMEOUT
    const [expirySeconds, setExpirySeconds] = useState(null);
    const renewInactivityRef = useRef(null);

    useEffect(() => {
        const timeoutMs = 600000;
        const warningMs = 60000;
        let deadline = Date.now() + timeoutMs;
        let timer;
        let warningLocked = false;
        let expired = false;

        const checkDeadline = () => {
            clearTimeout(timer);
            if (expired) return;
            const remaining = deadline - Date.now();
            if (remaining <= 0) {
                expired = true;
                // Commit the expiry-only dirty-state reset before navigation:
                // the existing router blocker must not retain protected UI.
                flushSync(() => {
                    setHasUnsavedChanges(false);
                    setShowUnsavedChangesPopup(false);
                    setShowLogoutPopup(false);
                });
                clearCacheData();
                localStorage.clear();
                navigate("/login?tokenExpired=true", { replace: true });
                return;
            }
            if (remaining <= warningMs) {
                warningLocked = true;
                setExpirySeconds(Math.ceil(remaining / 1000));
                // Align updates to the deadline after throttled timers resume.
                timer = setTimeout(checkDeadline, remaining % 1000 || 1000);
            } else {
                timer = setTimeout(checkDeadline, remaining - warningMs);
            }
        };
        const renew = () => {
            if (expired || Date.now() >= deadline) {
                checkDeadline();
                return;
            }
            deadline = Date.now() + timeoutMs;
            warningLocked = false;
            setExpirySeconds(null);
            checkDeadline();
        };
        const onActivity = () => {
            // A late event must honour elapsed time before considering renewal.
            if (Date.now() >= deadline - warningMs) checkDeadline();
            if (!warningLocked && !expired) renew();
        };
        const onVisibility = () => {
            if (document.visibilityState === "visible") checkDeadline();
        };
        const activityEvents = ["mousemove", "mousedown", "keydown", "touchstart"];
        activityEvents.forEach(event => document.addEventListener(event, onActivity));
        document.addEventListener("visibilitychange", onVisibility);
        window.addEventListener("focus", checkDeadline);
        renewInactivityRef.current = renew;
        checkDeadline();

        return () => {
            clearTimeout(timer);
            activityEvents.forEach(event => document.removeEventListener(event, onActivity));
            document.removeEventListener("visibilitychange", onVisibility);
            window.removeEventListener("focus", checkDeadline);
            renewInactivityRef.current = null;
        };
    }, [navigate, clearCacheData, setHasUnsavedChanges, setShowUnsavedChangesPopup, setShowLogoutPopup]);
    // #endregion

    return (
        <StyledPage className={`${props?.className || ""} ${aiChatSidePanelOpen ? "isSidePanelOpen" : ""}`}>
            <SessionExpiryDialog open={expirySeconds !== null} disableEscapeKeyDown
                aria-labelledby="session-expiry-title" aria-describedby="session-expiry-description"
                PaperProps={{ role: "alertdialog" }}>
                <div className="session-expiry-card">
                    <h2 id="session-expiry-title">SESSION EXPIRING</h2>
                    <p id="session-expiry-description">
                        For your security, you will be logged out due to inactivity in:
                    </p>
                    <div className="session-expiry-countdown" role="timer" aria-label="Time until logout">
                        {String(Math.floor((expirySeconds ?? 0) / 60)).padStart(2, "0")}:
                        {String((expirySeconds ?? 0) % 60).padStart(2, "0")}
                    </div>
                    <button type="button" autoFocus onClick={() => renewInactivityRef.current?.()}>
                        DON'T LOGOUT
                    </button>
                </div>
            </SessionExpiryDialog>
            <FullScreenOverlay show={showLogoutPopup && !hasUnsavedChanges}>
                <DialogBoxComponent
                    headingColor="#00AEEF"
                    title="Ready To Logout"
                    message="Are you sure want to logout?"
                    onClickYes={() => {
                        setShowLogoutPopup(false);
                        clearCacheData();
                        localStorage.clear();
                        navigate("/login");
                    }}
                    onClickNo={() => {
                        setShowLogoutPopup(false);
                    }}
                />
            </FullScreenOverlay>

            <nav className="main-header navbar navbar-expand ">
                <div className="left-btns">
                    <ul>
                        <li style={{ marginRight: "6px" }}>
                            <Link
                                to="#"
                                className={!canGoBack ? "disabled" : "enabled"}
                                onClick={e => (canGoBack ? goBack() : e.preventDefault())}>
                                <ChevronLeft className="text-default" height="16px" />
                            </Link>
                        </li>
                        <li>
                            <Link
                                to="#"
                                className={!canGoForward ? "disabled" : "enabled"}
                                onClick={e => (canGoForward ? goForward() : e.preventDefault())}>
                                <ChevronRight className="text-default" height="16px" />
                            </Link>
                        </li>
                    </ul>
                </div>

                <div className="center-btns">
                    {props?.centerBtns?.map(btn => {
                        const key = uuidv4();
                        return (
                            <Link
                                key={key}
                                to={
                                    !userIsOnboarding && hasOrganizationName && !btn?.disabled && btn?.to ? btn?.to : ""
                                }
                                className={
                                    btn?.disabled || userIsOnboarding || !hasOrganizationName
                                        ? "btn btn-success button-not-active"
                                        : "btn btn-success button-active"
                                }
                                onClick={
                                    btn?.disabled || userIsOnboarding || !hasOrganizationName
                                        ? e => {
                                              e.preventDefault();
                                          }
                                        : undefined
                                }>
                                {btn?.title}
                            </Link>
                        );
                    })}
                </div>

                <div ref={rightButtonsRef} className="right-btns navbar-nav ml-auto">
                    <div className="nav-item dropdown profile-container">
                        <Link
                            className="nav-link user-profile-dropdwon"
                            data-toggle="dropdown"
                            to="#"
                            onClick={() => setShowUserProfileDropdown(!showUserProfileDropdown)}
                            aria-expanded={showUserProfileDropdown}>
                            <div className={isProfileTextVisible ? "profile-text" : "profile-text is-hidden"}>
                                <span className="username">{localStorage?.getItem("userName")}</span>
                                <span className="user-designation">{localStorage?.getItem("currentProfileRole")}</span>
                            </div>
                            <div className="profile-picture-container" onClick={e => e.preventDefault()}>
                                {localStorage?.getItem("currentProfilePhoto") ? (
                                    <img
                                        className="profile-picture"
                                        src={localStorage?.getItem("currentProfilePhoto")}
                                        alt="Profile"
                                    />
                                ) : (
                                    <UserCircle className="text-inactive" height="35px" width="35px" />
                                )}
                            </div>
                            <div className="dropdown-icon text-gray-300">
                                <ChevronDown height="16px" width="16px" color="#D1D1D1" />
                            </div>
                        </Link>
                    </div>
                    <div
                        className="nav-item icon notification-bell"
                        onClick={() => {
                            setShowNotificationDropdown(!showNotificationDropdown);
                            if (!showNotificationDropdown) {
                                getHeaderNotifications();
                            }
                        }}>
                        <Link className="nav-link icon" to="#" onClick={e => e.preventDefault()} aria-expanded="true">
                            <div className="notification-bell-container">
                                {unreadCounts ? (
                                    <div
                                        className="notification-badge"
                                        style={unreadCounts > 100 ? { fontSize: "6px", alignItems: "center" } : {}}>
                                        {unreadCounts > 100 ? "99+" : unreadCounts}
                                    </div>
                                ) : (
                                    ""
                                )}
                                <Bell02 className="text-gray-100" height="22px" />
                            </div>
                        </Link>
                    </div>
                    <div className="nav-item icon">
                        <Link
                            className="nav-link btn btn-success button-not-active"
                            data-widget="search"
                            to="#"
                            onClick={e => e.preventDefault()}
                            role="button">
                            <Search className="text-inactive" height="16px" />
                        </Link>
                    </div>
                    <div className="nav-item icon">
                        <Link
                            id=""
                            className="nav-link btn btn-success"
                            to="#"
                            onClick={toogleFullscreen}
                            role="button">
                            <Expand06 className="text-default" height="16px" />
                        </Link>
                    </div>
                    <div className="nav-item icon logout-btn">
                        <Link
                            className="nav-link btn btn-success"
                            data-widget="logout"
                            to="#"
                            onClick={handleLogoutBtnClick}
                            role="button">
                            <Power01 className="text-green-500" height="16px" />
                        </Link>
                    </div>
                </div>
            </nav>

            <div className={`notifications-dropdown ${showNotificationDropdown ? "show" : ""}`}>
                <NotificationsDropdown
                    className=""
                    NotificationItems={notificationItems}
                    isLoadingNotifications={isLoadingNotifications}
                    setShowNotificationPanel={setShowNotificationPanel}
                    setShowNotificationDropdown={setShowNotificationDropdown}
                    getUnreadNotifications={getUnreadNotifications}
                    handleReadNotification={handleReadNotification}
                    handleDeleteNotification={handleDeleteNotification}
                    handleDestinationPage={handleDestinationPage}
                />
            </div>

            <div className={`user-profile-dropdown ${showUserProfileDropdown ? "show" : ""}`}>
                <UserProfileDropdown
                    handleLogoutBtnClick={handleLogoutBtnClick}
                    setShowUserProfileDropdown={setShowUserProfileDropdown}
                />
            </div>

            <Drawer
                anchor="right"
                open={showNotificationPanel}
                style={{ zIndex: 9999 }}
                onClose={() => setShowNotificationPanel(false)}>
                <NotificationPanel
                    setShowNotificationPanel={setShowNotificationPanel}
                    groupedUnreadNotifications={groupedUnreadNotifications}
                    readNotifications={readNotifications}
                    getReadNotifications={getReadNotifications}
                    getUnreadNotifications={getUnreadNotifications}
                    hasNextPage={hasNextPage}
                    readNotificationCount={readNotificationCount}
                    isLoading={isLoading}
                    handleDestinationPage={handleDestinationPage}
                    loadMoreLoading={loadMoreLoading}
                />
            </Drawer>
        </StyledPage>
    );
}

export default Header;
